// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import router from './router'

Vue.use(VueResource);

// WEBSERVICE CREDIENTIALS
Vue.http.options.root = 'http://schisisonderzoek.loc/wp-json/';
Vue.http.headers.common['Authorization'] = 'Basic '+ btoa('ruben:Geheim123!');
Vue.http.headers.common['Content-Type'] = 'application/json';

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js